import React, { useState, useRef, useEffect, Fragment } from 'react';
import close from '../../../assets/images/model/close.svg';
import filePlus from '../../../assets/images/model/upload_arrow.svg';
import infoCreate from '../../../assets/images/model/info-create.svg';
import polygonArrow from '../../../assets/images/model/Polygon-dowan-arrow.svg';
import { uploadMedia } from '../../../Store/api/create';
import { useDispatch } from 'react-redux';
import { useSelector } from 'react-redux';

const ImageUploader = ({ onImageUploaded, setUploadImageShow, onSuccess }) => {
  const [uploadImage, setUploadImage] = useState(true);
  const [uploadLoadedImage, setUploadLoadedImage] = useState(false);
  const [imageFile, setImageFile] = useState(null);
  const [uploadProgress, setUploadProgress] = useState(0);
  const [isLoading, setIsLoading] = useState(false);
  const { user } = useSelector((state) => state.auth);
  const [alt, setAlt] = useState('');
  const dropRef = useRef();
  const circleRef = useRef();
  let interval;
  const dispatch = useDispatch();
  const inputRef = useRef(null);

  useEffect(() => {
    const items = document.querySelectorAll('.progress-item');

    const newIntervals = Array.from(items).map((_, index) => {
      return setInterval(() => {
        const updatedPercentage = (uploadProgress / 100) * 100;

        items[index].style.background = `conic-gradient(var(--Purple-700, #6700B2) calc(${Math.round(updatedPercentage)}%),var(--Purple-300, #DDD5EB) 0deg)`;
        items[index].setAttribute('data-value', `${Math.round(updatedPercentage)}%`);
        items[index].textContent = `${Math.round(updatedPercentage)}%`;

        if (uploadProgress === 100) {
          clearInterval(newIntervals[index]);
        }
      }, 15);
    });

    return () => {
      newIntervals.forEach((interval) => clearInterval(interval));
    };
  }, [uploadProgress]);

  const updateProgress = (progress) => {
    if (circleRef.current) {
      const circle = circleRef.current.querySelector('b');
      const deg = (progress / 100) * 360;

      if (circle) {
        if (deg <= 180) {
          circle.style.setProperty('--rotate-before', `rotate(${deg}deg)`);
          circle.style.setProperty('--rotate-after', 'rotate(0deg)');
        } else {
          circle.style.setProperty('--rotate-before', 'rotate(180deg)');
          circle.style.setProperty('--rotate-after', `rotate(${deg - 180}deg)`);
        }
      }
    }
  };

  useEffect(() => {
    updateProgress(uploadProgress);
  }, [uploadProgress]);

  const handleImageUpload = (file) => {
    setIsLoading(true);
    const { type } = file;
    dispatch(
      uploadMedia({
        body: { fileType: type },
        onSuccess: async (res) => {
          try {
            await putFile(file, res.data.data.url);
            setUploadImage(false);
            setIsLoading(false);
            setUploadLoadedImage(true);
            setImageFile(res.data.data.key);
            onSuccess(res.data.data.key, '', '');
          } catch (error) {
            setIsLoading(false);
            console.error('Upload failed:', error);
          }
        },
        onError: (err) => {},
      })
    );
    // if (file) {
    //   setIsLoading(true);
    //   let progress = 0;
    //   interval = setInterval(() => {
    //     progress += 20;
    //     setUploadProgress(progress);
    //     updateProgress(progress);
    //     if (progress >= 100) {
    //       clearInterval(interval);
    //       setTimeout(() => {
    //         setUploadImage(false);
    //         setIsLoading(false);
    //         setUploadLoadedImage(true);
    //         setImageFile(URL.createObjectURL(file));
    //       }, 500);
    //     }
    //   }, 500);
    // }
  };

  const putFile = (file, url) => {
    return new Promise((resolve, reject) => {
      const xhr = new XMLHttpRequest();

      xhr.open('PUT', url, true);

      xhr.upload.onprogress = (event) => {
        if (event.lengthComputable) {
          const progress = (event.loaded / event.total) * 100;
          setUploadProgress(Math.round(progress));
        }
      };

      xhr.onload = () => {
        if (xhr.status >= 200 && xhr.status < 300) {
          resolve(xhr.response);
        } else {
          reject(new Error(`Upload failed: ${xhr.statusText}`));
        }
      };

      xhr.onerror = () => reject(new Error('Network error occurred'));

      xhr.send(file);
    });
  };

  const handleDoneButtonClick = () => {
    setUploadImageShow(false);
    setUploadProgress(0);
    if (onImageUploaded && imageFile) {
      onImageUploaded(imageFile);
    }
  };

  const handleClose = () => {
    setUploadImageShow(false);
    setUploadProgress(0);
  };

  const handleDragOver = (event) => {
    event.preventDefault();
    event.stopPropagation();
    dropRef.current.classList.add('drag-over');
  };

  const handleDragEnter = (event) => {
    event.preventDefault();
    event.stopPropagation();
    dropRef.current.classList.add('drag-over');
  };

  const handleDragLeave = (event) => {
    event.preventDefault();
    event.stopPropagation();
    dropRef.current.classList.remove('drag-over');
  };

  const handleDrop = (event) => {
    event.preventDefault();
    event.stopPropagation();
    dropRef.current.classList.remove('drag-over');
    const file = event.dataTransfer.files[0];
    handleImageUpload(file);
  };

  useEffect(() => {
    return () => {
      clearInterval(interval);
    };
  }, []);

  return (
    <div>
      <div className='modal custom_background custom_modal_create' id='upload_book' style={{ display: 'block' }} tabIndex='-1' aria-labelledby='upload_bookLabel' aria-hidden='true'>
        <div className='modal-dialog modal-dialog-centered'>
          <div className='modal-content'>
            <div className='modal-header'>
              <button onClick={handleClose} type='button' className='btn-close' data-bs-dismiss='modal' aria-label='Close'>
                <img src={close} alt='close' />
              </button>
            </div>
            <div className='modal-body-cre'>
              <h4>{uploadLoadedImage ? 'Add Image' : 'Upload Image'}</h4>
              {uploadImage && !isLoading && (
                <Fragment>
                  <p>Drag and drop an image file from your computer. Add attribution and accessibility options (like alt text) in the next step.</p>
                  <form action='' className='upload_book'>
                    <div
                      className='upload_book_inner my-40 mb-0'
                      ref={dropRef}
                      onDragOver={handleDragOver}
                      onDragEnter={handleDragEnter}
                      onDragLeave={handleDragLeave}
                      onDrop={handleDrop}
                      onClick={() => {
                        if (user?.role !== 'STUDENT') inputRef.current.click();
                      }}
                    >
                      <div className='drag_and_drop_box' htmlFor='Drag-file'>
                        <div className='upload_content'>
                          <div className='icon-create mb-24'>
                            <img src={filePlus} alt='upload' />
                          </div>
                          <div className='deflat_content'>
                            <h6 className='f-size-18 theme__primary__text'>
                              <span>Drag and drop file, or </span>
                              <label className='cursor' style={{ cursor: 'pointer' }}>
                                Browse
                              </label>
                              <input ref={inputRef} type='file' id='file-upload' accept='image/*, image/gif' style={{ display: 'none' }} onChange={(event) => handleImageUpload(event.target.files[0])} />
                            </h6>
                            <p>Supports png or jpeg files | Max size 20mb</p>
                          </div>
                        </div>
                      </div>
                    </div>
                  </form>
                </Fragment>
              )}

              {isLoading && (
                <Fragment>
                  <form action='' className='upload_book'>
                    <div className='upload_book_inner my-40 mb-0'>
                      <div className='drag_and_drop_box upload-boarder' htmlFor='Drag-file'>
                        <div className='upload_content'>
                          <div className='icon mb-24'> </div>
                          <div className='deflat_content'>
                            <div id='progress'>
                              <div data-num={uploadProgress} className='progress-item'>
                                {Math.round(uploadProgress)}%
                              </div>
                            </div>
                            <h6 className='f-size-18 theme__primary__text'>Uploading image...</h6>
                          </div>
                        </div>
                      </div>
                    </div>
                  </form>
                </Fragment>
              )}
              {uploadLoadedImage && imageFile && (
                <div className='add_img_cre'>
                  <div>
                    <img className='image_model' src={imageFile} alt='Uploaded' />
                  </div>
                  <form action='' className='pick_from_library'>
                    <div className='pick_from_library_filter_wrap'>
                      <div className='pick_from_library_filter my-40 mt-20'>
                        <div className='icon'>
                          <div className='tooltip_wrap'>
                            <h2 className='icon_h2 mb-0'>
                              Alt. text <img src={infoCreate} className='info_tooltip' alt='Info' />
                            </h2>
                            <p>
                              Describes images for people who have trouble seeing them <img src={polygonArrow} alt='Polygo' />
                            </p>
                          </div>
                          <textarea
                            style={{
                              fontSize: '20px',
                              height: '100px',
                              resize: 'none',
                            }}
                            className='pick_from_input_cre border_color'
                            placeholder='Write a detailed description of the image'
                          ></textarea>{' '}
                          <div className='tooltip_wrap Attribution'>
                            <h2 className='icon_h2 mb-0'>
                              Attribution <img src={infoCreate} className='info_tooltip' alt='Info' />
                            </h2>
                            <p>
                              Provide the source of the image to give creator credit <img src={polygonArrow} alt='Polygo' />
                            </p>
                          </div>
                          <textarea
                            placeholder='Paste the link...'
                            style={{
                              fontSize: '20px',
                              height: '60px',
                              resize: 'none',
                              boxSizing: 'border-box',
                            }}
                            className='pick_from_input_cre border_color place-holder-align'
                          />
                        </div>
                      </div>
                    </div>
                    <div className='modal-btn'>
                      <button type='button' className='btn-black_create' onClick={handleDoneButtonClick}>
                        Done
                      </button>
                    </div>
                  </form>
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ImageUploader;
